export const environment = {
  production: true,
  buildId: '3978653718024101',
  configFile: 'config.json',
};
